export const wrapperStyle = {
  background: "#0F054C",
  padding: "6rem 6rem 5rem",
  textAlign: "center",
  color: "#ffffff",
  height: "18rem",
};

export default wrapperStyle;
